import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="sticky top-0 z-50 bg-urgencyRed text-white py-2 px-4 text-center font-montserrat font-bold text-sm md:text-base shadow-md" data-id="element-215">
      <div className="flex items-center justify-center gap-2 animate-pulse" data-id="element-216">
        <span data-id="element-217">🔥 OFERTA ESPECIAL TERMINA EN:</span>
        <span className="font-mono text-lg bg-white/20 px-2 py-0.5 rounded" data-id="element-218">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}